type TFunction = (key: string, options?: { defaultValue?: string }) => string;

const ROLE_KEYS: Record<string, string> = {
  ADMIN: 'employees.roles_ADMIN_label',
  MEMBER: 'employees.roles_MEMBER_label',
  GUEST: 'employees.roles_GUEST_label',
  OWNER: 'employees.roles_OWNER_label',
};

export function getRoleLabel(role: string, t: TFunction): string {
  if (!role) return '';
  const key = ROLE_KEYS[role];
  if (key) {
    const fallback = role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
    return t(key, { defaultValue: fallback });
  }
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
}
